import request from '@/axios'

// 请假申请
export const addLeaveApply = (data) => {
  return request.post({ url: '/api/leave/apply', data })
}

// 获取请假天数
export const getLeaveDuration = (params) => {
  return request.get({ url: '/api/leave/getDuration', params })
}

// 我发起的
export const getMyApplicationsAll = (data) => {
  return request.post({ url: '/api/leave/myApplicationsAll', data })
}

// 审批请假
export const postApprove = (data) => {
  return request.post({ url: '/api/leave/approve', data })
}

// 获取请假详情
export const getLeaveDetail = (id: string) => {
  return request.get({ url: `/api/leave/leaveDetail/${id}` })
}

// 我审批的
export const getPendingApprovalsAll = (data) => {
  return request.post({ url: '/api/leave/pendingApprovalsAll', data })
}

// 统一调休 无需审核
export const postDeductLeave = (data) => {
  return request.post({ url: '/api/leave/deductLeave', data })
}
